/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Lookup_Manage_Guides_ButtonInputs */



/**
* | output |
* | --- |
* | "Manage KNP Guides" |
*
* @param {Knp_Lookup_Manage_Guides_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_lookup_manage_guides_button = /** @type {((inputs?: Knp_Lookup_Manage_Guides_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Lookup_Manage_Guides_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Gerer les guides KNP")
	if (locale === "de") return /** @type {LocalizedString} */ ("KNP-Guides verwalten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gestisci le guide KNP")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Управление гидами КНП")
	if (locale === "es") return /** @type {LocalizedString} */ ("Administrar guías KNP")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("管理克鲁格国家公园导游")
	if (locale === "ja") return /** @type {LocalizedString} */ ("KNPガイドの管理")
	if (locale === "hi") return /** @type {LocalizedString} */ ("केएनपी गाइड प्रबंधित करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Gerenciar Guias do KNP")
	return /** @type {LocalizedString} */ ("Manage KNP Guides")
});